import { EMemberRole } from "./types";

export const dateFormat = "DD.MM.YYYY";

export const sidebarWidth = "240px";
export const scrollableLayoutOffset = "56px";
// url was changed
export const bimFolderRegex = /^/;

export const commentsTabs = [
  "В работе",
  "Отправленные в ПИ",
  "Отклонённые",
  "Отработанные",
] as const;

export const defaultItemsLimit = 9;

export const engineerRoleNameByRoleId: Record<EMemberRole, string> = {
  [EMemberRole.ARCHITECTURAL_SUPERVISION]: "Специалист авторского надзора",
  [EMemberRole.CHIEF_PROJECT_ENGINEER]: "Главный инженер проекта",
  [EMemberRole.CHIEF_PROJECT_ENGINEER_PI]: "ГИП проектного института",
  [EMemberRole.CHIEF_PTO_SPECIALIST]: "Главный специалист ПТО",
  [EMemberRole.LEAD_PTO_ENGINEER]: "Ведущий инженер ПТО",
  [EMemberRole.PROJECT_MANAGER]: "Руководитель проекта",
  [EMemberRole.PTO_ENGINEER]: "Инженер ПТО",
};
// url was changed
export const centrifugoUrls = {
  production: "WS-connection",
};
